import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../AuthContext";

const GuestRoute = ({ children }) => {
  const { isAuthenticated, isAdmin, loading } = useAuth();

  if (loading) {
    return <div className="p-6">Chargement...</div>;
  }

  if (isAuthenticated && isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default GuestRoute;